export default __webpack_public_path__ + "static/media/_IMG5767.2e74f654.jpg";